import React,{ useState }  from 'react';
import { Form, Input, Button, Select, message, Row } from 'antd';
import { UserOutlined, MailOutlined, LockOutlined, IdcardOutlined } from '@ant-design/icons';
import '../../styles/LoginForm.css';
import { createUser, userRegister } from '../../services/AuthService';
import { useNavigate } from 'react-router-dom';
const { Option } = Select;

const RegisterForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // Loading state

    // Function to handle registration
const registerService = async (values, setLoading, navigate) => {
    try {
      const { email, name, password, phoneNumber, role } = values; 
      setLoading(true);// Destructure values from the form
      const user = await createUser(email, name, password, phoneNumber, role); // Call the userRegister service
  
      if (user) {
        localStorage.removeItem('roleType');
        localStorage.removeItem('userName');
        localStorage.clear();
        message.success('Registration successful!'); // Show success message
        navigate('/login'); // Redirect to login page after successful registration
      } else {
        message.error('Registration failed, please try again.'); // Show error message if no user
      }
    } catch (error) {
        
      console.error('Registration error:', error);
      message.error('Registration failed, please try again.'); // Handle registration failure
    } finally {
      setLoading(false); // Stop loading after request completes
    }
  };
  const onFinish = async (values) =>  {
    console.log('Received values of form: ', values);
    await registerService(values, setLoading, navigate); 
  };

  return (
    <div className="login-form-container">
      <Form
        name="register_form"
        className="login-form"
        initialValues={{ remember: true }}
        onFinish={onFinish}
      >
        <div className="logo-container" >
          <img src="/logo.png" alt="Logo" className="logo-auth" />
        </div>
        <Row justify="center" style={{ marginBottom: '10px' }}>
          <p>Please fill in the fields below to register.</p>
        </Row>
        

        {/* Name Field */}
        <Form.Item
          name="name"
          rules={[{ required: true, message: 'Please input your name!' }]}
        >
          <Input prefix={<IdcardOutlined className="site-form-item-icon" />} placeholder="Name" size="large" />
        </Form.Item>

        {/* Email Field */}
        <Form.Item
          name="email"
          rules={[
            { type: 'email', message: 'The input is not valid E-mail!' },
            { required: true, message: 'Please input your E-mail!' }
          ]}
        >
          <Input prefix={<MailOutlined className="site-form-item-icon" />} placeholder="Email" size="large" />
        </Form.Item>

        {/* Password Field */}
        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Please input your Password!' }]}
        >
          <Input.Password
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Password"
            size="large"
          />
        </Form.Item>

        {/* Confirm Password Field */}
        <Form.Item
          name="confirm"
          dependencies={['password']}
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Please confirm your password!',
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('The two passwords do not match!'));
              },
            }),
          ]}
        >
          <Input.Password
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Confirm Password"
            size="large"
          />
        </Form.Item>

        {/* Role Type (Viewer/Content) Field */}
        <Form.Item
          name="role"
          rules={[{ required: true, message: 'Please select a role!' }]}
        >
          <Select placeholder="Select a role" style={{ width: '100%' }} size="large">
            <Option value="EDITOR">EDITOR</Option>
            <Option value="READER">READER</Option>
          </Select>
        </Form.Item>

        {/* Submit Button */}
        <Form.Item>
          <Button type="primary" htmlType="submit" className="login-form-button"
          
           size="large" 
           loading={loading}
           block >
            Register
          </Button>
          <Row justify="center">
                    <p>  Already have an account? </p>
                    <p 
                      type="link" 
                      onClick={() => navigate('/login')} 
                      style={{ color: '#1890ff', cursor: 'pointer', marginLeft: '5px' }} // Add effect to link
            >
               Log in
            </p>
          </Row>
         
        </Form.Item>
      </Form>
    </div>
  );
};

export default RegisterForm;
